/**
 * Slug de la liga leído de la URL real (FEATURE-050 / FEATURE-205).
 *
 * Vive en `lib/` y **no importa nada de `src/app/**` ni `src/components/**`** a propósito:
 * lo consume [`analytics.ts`](./analytics.ts), que el layout de `[locale]` carga en **todas**
 * las páginas. Dejarlo en `leagues/href.ts` —donde nació— metería `LeagueNav` (un `"use
 * client"` con Context) y los feature flags en el bundle de marketing, login, admin y acta
 * (FEATURE-205 RNF-01).
 *
 * `leagues/href.ts` re-exporta ambos símbolos, así que sus consumidores históricos siguen
 * importándolos de ahí sin cambios.
 */

/**
 * Rutas de sistema en la raíz que NO son slugs de liga. **Contrato compartido** con la
 * CloudFront Function (FEATURE-002) y el saneamiento de slugs en `api/`: se deriva de los
 * prefijos sin extensión que existen en la raíz del bucket. Toda carpeta nueva bajo
 * `web/public/`, todo locale nuevo y toda ruta top-level nueva debe sumarse aquí, o esa
 * ruta caería al shell del hincha (FEATURE-050 §12 R-002).
 */
export const DENYLIST = ["es", "_next", "logos-ref"];

/**
 * Lee el slug de la liga del primer segmento del path (forma corta `/<slug>`). Devuelve
 * `null` cuando no hay slug en el path (forma larga `/<locale>/leagues`, dev): segmento
 * vacío, con `.` (archivo: favicon, etc.) o en la `DENYLIST`. En SSR/prerender (sin
 * `window`) devuelve `null` — la siembra real ocurre en el cliente (FEATURE-050 RF-1).
 */
export function slugFromPath(): string | null {
  if (typeof window === "undefined") return null;
  const seg = window.location.pathname.split("/")[1] ?? "";
  if (seg === "" || seg.includes(".") || DENYLIST.includes(seg)) return null;
  return seg;
}
